import * as React from 'react'

function SvgFunVeiwGrid(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M10 13a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6a1 1 0 011-1h6zm10 0a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6zM9 15H5v4h4v-4zm10 0h-4v4h4v-4zM10 3a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h6zm10 0a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1V4a1 1 0 011-1h6zM9 5H5v4h4V5zm10 0h-4v4h4V5z" />
    </svg>
  )
}

export default SvgFunVeiwGrid
